import { useState, useRef, useEffect } from 'react';
import { useApp } from '@/contexts/AppContext';
import { Plus, FileText, BookOpen, X } from 'lucide-react';

export default function FAB() {
  const { createNote, createJournalEntry, setActiveView, setFilterNotebookId, setFilterTagId } = useApp();
  const [open, setOpen] = useState(false);
  const fabRef = useRef(null);

  // Close on outside click
  useEffect(() => {
    if (!open) return;
    const handler = (e) => {
      if (fabRef.current && !fabRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handler);
    document.addEventListener('touchstart', handler);
    return () => {
      document.removeEventListener('mousedown', handler);
      document.removeEventListener('touchstart', handler);
    };
  }, [open]);

  const handleNewNote = async () => {
    setOpen(false);
    setActiveView('all');
    setFilterNotebookId(null);
    setFilterTagId(null);
    await createNote();
  };

  const handleNewJournalEntry = async () => {
    setOpen(false);
    await createJournalEntry();
  };

  return (
    <div
      ref={fabRef}
      className="fixed bottom-6 right-6 z-50 flex flex-col items-end gap-2 lg:hidden"
      data-testid="fab-container"
    >
      {/* Expanded options */}
      {open && (
        <div className="flex flex-col items-end gap-2 mb-1 animate-in fade-in slide-in-from-bottom-2 duration-200">
          <button
            onClick={handleNewNote}
            className="flex items-center gap-2.5 pl-4 pr-4 py-2.5 rounded-full bg-card border border-border shadow-lg text-sm font-medium text-foreground hover:bg-muted transition-colors"
            data-testid="fab-new-note"
          >
            <FileText className="w-4 h-4" />
            New Note
          </button>
          <button
            onClick={handleNewJournalEntry}
            className="flex items-center gap-2.5 pl-4 pr-4 py-2.5 rounded-full bg-card border border-border shadow-lg text-sm font-medium text-foreground hover:bg-muted transition-colors"
            data-testid="fab-new-journal-entry"
          >
            <BookOpen className="w-4 h-4" />
            New Journal Entry
          </button>
        </div>
      )}

      {/* Main FAB button */}
      <button
        onClick={() => setOpen(!open)}
        className={`w-14 h-14 rounded-full shadow-lg flex items-center justify-center transition-all duration-200 ${
          open
            ? 'bg-muted text-foreground rotate-45'
            : 'bg-accent-amber text-black hover:bg-accent-amber/90'
        }`}
        data-testid="fab-main-btn"
      >
        {open ? <X className="w-6 h-6" /> : <Plus className="w-6 h-6" />}
      </button>
    </div>
  );
}
